import { render, staticRenderFns } from "./endetlawapa.vue?vue&type=template&id=4bab791c&scoped=true&"
import script from "./endetlawapa.vue?vue&type=script&lang=js&"
export * from "./endetlawapa.vue?vue&type=script&lang=js&"
import style0 from "./endetlawapa.vue?vue&type=style&index=0&id=4bab791c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab791c",
  null
  
)

export default component.exports